export type TPlatformType = 'chrome' | 'windows';

export const downloadLinkByPlatformMap = new Map<TPlatformType, string>([
  ['chrome', 'https://chromewebstore.google.com/detail/blesk/bombgjmnkojifbkkmnhfanibpccelgda'],
  ['windows', 'https://s3.twcstorage.ru/blesk-apps/Blesk_0.7.1_x64-setup.exe'],
]);
